import script from "./AcceptFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptFiles.vue?vue&type=script&setup=true&lang=js"

import "./AcceptFiles.vue?vue&type=style&index=0&id=60cae4f5&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60cae4f5"]])

export default __exports__